import * as React from 'react'
import Hotel from 'components/hotel'
import { Waypoint } from 'react-waypoint'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import styles from './styles.module.scss'
import { categories } from '../../global/categories'

interface WaypointEvent {
  currentPosition: string
  previousPosition: string
}

interface Props {
  category: string
  hotelList: Map<string, string | number>[]
  id: string
  request: 'loading' | 'error' | 'ready'
  topWaypointLeaveHandler: (id: string, waypointEvent: WaypointEvent) => void
  bottomWaypointLeaveHandler: (id: string, waypointEvent: WaypointEvent) => void
}

export function HotelCategory({
  category,
  hotelList,
  id,
  request,
  topWaypointLeaveHandler,
  bottomWaypointLeaveHandler
}: Props) {
  const segmentClasses = `ui relaxed vertical attached ${request} ${styles.hotelCategory} segment`

  const hotelMapToProps = (hotel: Map<string, string | number>) => ({
    address: hotel.get('Adresse'),
    category: hotel.get('Kategorie'),
    description: hotel.get('Legende'),
    host: hotel.get('Gastgeber'),
    image: hotel.get('Bild'),
    winnerText: hotel.get('Siegertext'),
    name: hotel.get('Name'),
    phone: hotel.get('Telefon'),
    previousRank: hotel.get('RangimVorjahr'),
    price: hotel.get('Preis'),
    rank: parseInt(hotel.get('Rang'), 10),
    stars: parseInt(hotel.get('Sterne'), 10),
    typeOfStay: hotel.get('TypderÜbernachtung'),
    website: hotel.get('Webseite')
  })

  // sort the hotel list and retrieve the first place
  hotelList.sort((a, b) => a.get('Rang') - b.get('Rang'))
  const firstPlace = hotelList.shift()
  let firstHotelProps = {}
  if (firstPlace) {
    firstHotelProps = hotelMapToProps(firstPlace)
  }

  return (
    <main className={segmentClasses} id={id}>
      <Waypoint
        scrollableAncestor={window}
        onLeave={({ previousPosition, currentPosition }) => {
          if (
            previousPosition === Waypoint.inside &&
            currentPosition === Waypoint.above
          ) {
            topWaypointLeaveHandler(id)
          }
        }}
        topOffset='25%'
      />

      <Waypoint
        scrollableAncestor={window}
        onEnter={event => {
          if (event.previousPosition === 'below') {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: id + ' startReading'
            })
          }
        }}
      />

      <div className='ui text container'>
        <h2
          className='ui centered header'
          style={{ color: categories[category][1] }}
        >
          {category}
        </h2>
        <div className='ui horizontal divider'>
          <i className='grey disabled sun icon' />
        </div>
      </div>

      <div className='ui container'>
        <div
          className={`ui segment ${styles.winnerSegment}`}
          style={{ background: '#E6E6EA' }}
        >
          <div className='ui middle aligned mobile reversed two column stackable grid'>
            <div className='ui column mobile hidden'>
              <div className='ui vertical very fitted text basic segment'>
                <h3
                  className='ui centered header'
                  style={{ color: categories[category][1] }}
                >
                  <div className={`sub header ${styles.subHeader}`}>
                    {firstPlace && firstPlace.get('Name')}
                  </div>
                  {firstPlace && firstPlace.get('SiegertextTitel')}
                </h3>

                <p>{firstPlace && firstPlace.get('Siegertext')}</p>
              </div>
            </div>
            <div className='ui column'>
              {firstPlace && <Hotel className='fluid' {...firstHotelProps} />}
            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui three doubling stackable cards'>
            {hotelList.map(hotel => {
              const hotelProps = hotelMapToProps(hotel)
              return (
                <Hotel
                  {...hotelProps}
                  key={hotelProps.name + '-' + hotelProps.rank}
                />
              )
            })}
          </div>
        </div>
      </div>
      <Waypoint
        scrollableAncestor={window}
        onLeave={({ previousPosition, currentPosition }) => {
          if (
            previousPosition === Waypoint.inside &&
            currentPosition === Waypoint.below
          ) {
            bottomWaypointLeaveHandler(id)
          }
        }}
        bottomOffset='25%'
      />
    </main>
  )
}
